import React from 'react'

import collection_title from '../../styles/components/homePage/collection_title'

const Title = ({ title }) => (
  <div className='collection-title-container'>
    <div className='collection-title'>{title}</div>
    <style jsx>{collection_title}</style>
  </div>
)

export default Title
